import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { Chart, registerables } from 'chart.js'
import { BarChart, useBarChart } from 'vue-chart-3'
import { computed, PropType, reactive } from 'vue'
import { OldObservationHistoryType } from '@/shared/types'
import { getDateFormat } from '@/shared/utils'
import { DATE_FORMAT } from '@/shared/constants'


export default /*#__PURE__*/_defineComponent({
  props: {
  history: Array as PropType<OldObservationHistoryType[]>,
},
  setup(__props) {

const props = __props

Chart.register(...registerables)



const chartHeight = computed(() => props.history.length * 45)

const month = computed(() => props.history.map((value) => value.month))
const week = computed(() => props.history.map((value) => value.week))
const day = computed(() => props.history.map((value) => value.day))
const result = computed(() => props.history.map((value) => value.result))

const labels = computed(() =>
  props.history.map((value) =>
    getDateFormat(new Date(value.dateAt), DATE_FORMAT.dmyShort)
  )
)

const datasets = computed(() => [
  {
    data: month.value,
    backgroundColor: ['#824ee2'],
    barThickness: 10,
  },
  {
    data: week.value,
    backgroundColor: ['#bb66f6'],
    barThickness: 10,
  },
  {
    data: day.value,
    backgroundColor: ['#e697fa'],
    barThickness: 10,
    borderRadius: 20,
  },
  {
    data: createBackgroundDataset(),
    backgroundColor: ['#fafafa'],
    barThickness: 10,
  },
])

const chartData = reactive({
  labels,
  datasets,
})

const plugins = {
  legend: {
    display: false,
  },
  tooltip: {
    enabled: false,
  },
}

const scales = {
  x: {
    grid: {
      tickColor: 'transparent',
    },
    stacked: true,
    max: 100,
    ticks: {
      stepSize: 20,
      color: 'transparent',
      font: {
        size: 10,
      },
      callback: (value) => {
        if (value === 0) {
          return value
        }

        return value + '%'
      },
    },
  },
  y: {
    grid: {
      tickColor: 'transparent',
      drawOnChartArea: false,
    },
    stacked: true,
    ticks: {
      font: {
        size: 12,
      },
    },
  },
}

const createBackgroundDataset = (): number[] => {
  const backgroundData: number[] = []

  for (let i = 0; i < month.value.length; i++) {
    backgroundData.push(100)
  }

  return backgroundData
}

const displayBarLabels = (currentChart) => {
  const context = currentChart.chart.ctx
  context.font = '12px'
  context.textAlign = 'center'
  context.textBaseline = 'bottom'

  const meta = currentChart.chart.getDatasetMeta(0)

  meta.data.forEach((bar, index) => {
    context.fillStyle = '#4607af'
    context.fillText(`${month.value[index]}% — за месяц`, 135, bar.y - 5)

    context.fillStyle = '#bb66f6'
    context.fillText(`${week.value[index]}% — за неделю`, 250, bar.y - 5)

    context.fillStyle = '#e697fa'
    context.fillText(`${day.value[index]}% — за сутки`, 355, bar.y - 5)

    const xMax = currentChart.chart.width - 35

    context.fillStyle = '#5b5565'
    context.fillText(`${result.value[index]}%`, xMax, bar.y + 7)
  })
}

const displayXAxes = (currentChart): void => {
  const chart = currentChart.chart
  const context = chart.ctx
  const xAxis = chart.scales.x
  const ticksCount = xAxis.ticks.length

  const xOffsetStart = xAxis.width / (ticksCount - 1)

  context.fillStyle = '#a8a3b0'
  context.font = '10px Manrope'

  xAxis.ticks.forEach((tick, index) => {
    const yOffset = chart.height - 5

    let xOffset = xOffsetStart * index + 93

    if (tick.value === 100) {
      xOffset = xOffsetStart * index + 90
    }

    context.fillText(tick.label, xOffset, yOffset)
  })
}

const options = {
  indexAxis: 'y',
  events: [],
  hover: false,
  maintainAspectRatio: false,
  plugins,
  scales,
  animation: {
    duration: 500,
    onComplete(currentChart) {
      displayBarLabels(currentChart)
      displayXAxes(currentChart)
    },
  },
}

const { barChartProps } = useBarChart({
  chartData: chartData,
  options,
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle(`height: ${_unref(chartHeight)}px`)
  }, [
    _createVNode(_unref(BarChart), _mergeProps({ class: "old-history-chart" }, _unref(barChartProps)), null, 16)
  ], 4))
}
}

})